// src/hooks/useDynamicBackground.js

import { useState, useEffect } from 'react';

const useDynamicBackground = () => {
  const [backgroundUrl, setBackgroundUrl] = useState('');

  const getTimeBasedBackground = () => {
    const now = new Date();
    const hour = now.getHours();
    
    // Determine time type based on current hour
    let timeType;
    if (hour >= 6 && hour < 18) {
      timeType = 'day';
    } else if (hour >= 18 && hour < 21) {
      timeType = 'sunset';
    } else {
      timeType = 'night';
    }
    
    // Generate random number between 1-3 for image variation
    const imageNumber = Math.floor(Math.random() * 3) + 1;
    
    // Construct the URL
    const url = `https://static.reservaties.net/images/screensavers/${timeType}/${imageNumber}.webp`;
    
    return url;
  };

  useEffect(() => {
    // Set initial background
    setBackgroundUrl(getTimeBasedBackground());
    
    // Update background every minute to check for time changes
    const interval = setInterval(() => {
      setBackgroundUrl(getTimeBasedBackground());
    }, 60000); // Check every minute
    
    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  return backgroundUrl;
};

export default useDynamicBackground;